<div class="modal-header">
	<h4 class="modal-title fw-bold">
		@if (modeView === ModeView.VIEW) {
			<span jhiTranslate="ontology-manager.tab.methods.modal.detail.header"></span>
		} @else if (modeView === ModeView.EDIT) {
			<span jhiTranslate="ontology-manager.tab.methods.modal.edit.header"></span>
		} @else if (modeView === ModeView.CREATE) {
			<span jhiTranslate="ontology-manager.tab.methods.modal.create.header"></span>
		}
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal"
			(click)="clear()">
	</button>
</div>
<div class="modal-body">
	<div class="row" *ngIf="showNoEditableFieldAlert()">
		<div class="col">
			<div class="alert alert-warning" role="alert">
				<i class="fa fa-warning pe-2"></i>
				<span jhiTranslate="ontology-manager.validation.method.noneditableFields"></span>
			</div>
		</div>
	</div>
	<form name="form" #f="ngForm">
		<div class="mb-3 row">
			<label for="methodName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.methods.modal.method.name">Name</label>
			<div class="col-sm-9">
				<jhi-input
					name="methodName"
					[property]="'name'"
					[model]="methodDetails"
					[modeView]="modeView"
					[disabled]="isLoading"
					[required]="true"
					[maxLength]="NAME_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="methodDetails.name"
					#methodName="ngModel">
				</jhi-input>
				@if ((f.submitted || methodName.touched) && methodName.errors?.['required']) {
					<div class="text-danger pt-2" *ngIf="methodName.errors?.['required']">{{ 'ontology-manager.validation.name.required' | translate }}</div>
				} @else if ((f.submitted || methodName.dirty) && methodName.errors?.['maxlength']) {
					<div class="text-danger pt-2" *ngIf="methodName.errors?.['maxlength']">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: NAME_TEXT_LIMIT } }}</div>
				} @else if ((f.submitted || methodName.dirty) && methodName.errors?.['pattern']) {
					<div class="text-danger pt-2" *ngIf="methodName.errors?.['pattern']">{{ 'ontology-manager.validation.name.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
				}
			</div>
		</div>
		<div class="mb-3 row">
			<label for="description" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.methods.modal.method.description">Description</label>
			<div class="col-sm-9">
				<jhi-textarea
					name="descrription"
					[modeView]="modeView"
					[model]="methodDetails"
					[property]="'description'"
					[disabled]="isLoading"
					[required]="false"
					[maxLength]="DESCRIPTION_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="methodDetails.description"
					#description="ngModel">
				</jhi-textarea>
				@if (f.submitted || description.dirty) {
					@if (description.errors?.maxlength) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: DESCRIPTION_TEXT_LIMIT } }}</div>
					} @else if (description.errors?.pattern) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.description.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
					}
				}
			</div>
		</div>
	</form>
	<br>
	<jhi-metadata [modeView]="modeView" [metadata]="methodDetails.metadata" [extendedUsage]="false"></jhi-metadata>
</div>
<div class="modal-footer">
	@if (modeView === ModeView.EDIT || modeView === ModeView.CREATE) {
		<button type="button" class="btn btn-secondary" (click)="discard()">
			<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="discard"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;
			@if (modeView === ModeView.EDIT) {
				<span jhiTranslate="update"></span>
			} @else {
				<span jhiTranslate="create"></span>
			}
		</button>
	} @else {
		<button type="button" class="btn btn-secondary" (click)="clear()">
			<span jhiTranslate="back"></span>
		</button>
		@if (isDeletable()) {
			<button type="button" class="btn btn-info me-2" (click)="delete()">
				<span class="fa fa-trash"></span>&nbsp;<span jhiTranslate="delete"></span>
			</button>
		}
		<button type="button" class="btn btn-outline-info" (click)="edit()">
			<span class="fa fa-pencil"></span>&nbsp;<span jhiTranslate="edit"></span>
		</button>
	}
</div>
